import { dataFetcher } from 'core/services/requestHandler';   

const userSignin = async (data = {}, config = {}) => {
  return dataFetcher('authenticate', data, {method: 'POST', ...config});
};

const resetPassword = async (data = {}, config = {}) => {
  return dataFetcher('resetPassword', data, {method: 'POST', ...config});
};

const sendPasswordResetOTP = async (data = {}, config = {}) => {
  return dataFetcher('sendPasswordResetOTP', data, {...config});
};

const validateForgotPasswordOTP = async (data = {}, config = {}) => {
  return dataFetcher('validateOTP', data, {...config});
};

const DeleteUserInfoInBrowser = () => {
  window.localStorage.removeItem('rpgmUserInfo');
}

const sendSignUpOTP = (data = {}, config = {}) => {
  return dataFetcher('sendOTP', data, {...config});
}

const registerUser = (data = {}, config = {}) => {
  return dataFetcher('register', data, {method: 'POST', ...config});
}

const validateSignUpOTP = async (data = {}, config = {}) => {
  return dataFetcher('validateOTP', data, {...config});
};

export { userSignin, resetPassword, DeleteUserInfoInBrowser, sendPasswordResetOTP, validateForgotPasswordOTP, sendSignUpOTP, registerUser, validateSignUpOTP   };
